/**
 * This state/reducer focuses on modes that the user can change such as the soldto/payers.
 */
import * as types from '../constants/ActionTypes';

const initialState = {
  loginChecked: false,
  isLoggedIn: false,
  loginCount: 0,
  lastUrl: '/invoices',
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_LOGIN_CHECKED:
      return {...state, loginChecked: action.payload.checked,  isLoggedIn: action.payload.isLoggedIn, loginCount: state.loginCount++};
    case types.SET_IS_LOGGED_IN:
      return {...state, isLoggedIn: action.payload, loginCount: state.loginCount++};
    case types.LOGOUT:
      return {...state, isLoggedIn: false};
    case types.SET_LAST_URL:
      return {...state, lastUrl: action.payload};
    default:
      return {...state};
  }
}
